import { useDispatch, useSelector } from 'react-redux';
import DocForm from '../../components/docs/DocForm';
import FirstBuyerInformation from '../../components/docs/FirstBuyerInformation';
import FirstSellerInformation from '../../components/docs/FirstSellerInformation';
import InsuranceInformation from '../../components/docs/InsuranceInformation';
import LienHolderInformation from '../../components/docs/LienHolderInformation';
import SecondBuyerInformation from '../../components/docs/SecondBuyerInformation';
import SecondSellerInformation from '../../components/docs/SecondSellerInformation';
import TransactionInfoForm from '../../components/docs/TransactionInfoForm';
import VehicleInfo from '../../components/docs/VehicleInfo';
import { selectDocsError } from '../../redux-state/selectors';
import ErrorDialog from '../../components/common/error-dialog';

function Docs({ errors, isMultiStep }) {
  const apiError = useSelector(selectDocsError);
  const dispatch = useDispatch();

  const handleCloseError = () => {
    dispatch({ type: 'CLEAR_DOCS_ERROR' });
  };

  return (
    <div className="flex flex-col lg:flex-row w-full gap-6">
      {/* Left side */}
      <div className="flex flex-col gap-6 mt-4 w-full lg:w-1/2">
        <DocForm errors={errors} />
        <VehicleInfo errors={errors} />
        <TransactionInfoForm errors={errors} />
      </div>
      {/* Right side */}
      <div className="flex flex-col gap-4 mt-4 w-full lg:w-1/2">
        <FirstBuyerInformation />
        <SecondBuyerInformation />
        <FirstSellerInformation />
        <SecondSellerInformation />
        <InsuranceInformation />
        <LienHolderInformation />
      </div>
      {!isMultiStep && <ErrorDialog backendError={apiError} onClose={handleCloseError} /> }
    </div>
  );
}

export default Docs;
